module.exports = __webpack_public_path__ + "static/media/rolling-on-the-floor-laughing-144.c5153e3d.png";